import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { PublishingRuleViolationsView } from "../common"

export interface GetPublishingRuleViolationsViewPathParams {
	inventoryId: string
}

export const getPublishingRuleViolationsViewRoute: ApiRoute<
	GetPublishingRuleViolationsViewPathParams,
	NoQueryParams,
	NoBody,
	PublishingRuleViolationsView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/publishing-rule-violations`,
	method: "get",
	path: "/vehicles/:inventoryId/publishing-rule-violations",
}
